export const Countries = ["US", "CA"];
export enum CountriesEnum {
  USA = "US",
  CANADA = "CA",
}
